import { distinctUntilChanged, MonoTypeOperatorFunction } from 'rxjs';
import { isEqual } from 'lodash';

/**
 * A reusable distinctUntilChanged operator that uses lodash.isEqual for deep comparison.
 */
export const distinctUntilDeepChanged = <T>(): MonoTypeOperatorFunction<T> => {
  return distinctUntilChanged<T>((previous: T, current: T) => isEqual(previous, current));
};
